import { projectAuth } from '@/firebase/config'

export const beforeEachRouterEntry = async (to, _from, next) => {
  const currentUser = projectAuth.currentUser
  const requiresAuth = to.matched.some(record => record.meta.requiresAuth)

  if (requiresAuth && !currentUser) {
    next('login')
  } else if (!requiresAuth && currentUser) {
    next('/')
  } else {
    next()
  }
}

export default { beforeEachRouterEntry }
